import React from 'react';
import lodash from 'lodash';
import { useLocation } from 'react-router-dom';
import PartnerImpersonationDropdown from './PartnerImpersonationDropdown';

const PARTNER_PATH_LIST = [
   'ADVERTISER',
   'JOB-FEED',
   'MNG-ALERT',
   'SYN-ADS',
   'SYN-JOB-FEED',
   'SYN-SITES',
   'SPONSORED-ADS',
   'SYNDICATED-SPONSORED-ADS',

   // path used to redirect user after a partner-super-admin successfully impersonates a user
   'PARTNER',
];

// Depending on the URL path, employer impersonation or partner impersonation or NONE is displayed on the navbar
const ImpersonationDropdown = (props) => {
   const location = useLocation();
   const pathNameList = location.pathname.split('/').filter((p) => p);
   let rootPath = pathNameList.length > 0 ? pathNameList[0] : undefined;
   if (lodash.isString(rootPath)) {
      rootPath = rootPath.toUpperCase();
   }
   const isCurrPathUnderPartner = PARTNER_PATH_LIST.includes(rootPath);

   return (
      <>
         {
            // Employer impersonation (AOE-backed) was retired with the AOE
            // shutdown 2026-08-13 — it used to render whenever the URL root
            // was /employer/*, which includes the surviving KEEP twins.
            isCurrPathUnderPartner && (<PartnerImpersonationDropdown/>)
         }
      </>
   );
};

export default ImpersonationDropdown;
